import { CognitoIdentityProviderClient, GetUserAttributeVerificationCodeCommand } from "@aws-sdk/client-cognito-identity-provider";
import { fetchAuthSession } from "aws-amplify/auth";
import config from "../amplifyconfiguration.json";

// Envía un SMS con código de verificación al número de teléfono del usuario
const SendPhoneVerificationCode = async () => {
  try {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();

    const client = new CognitoIdentityProviderClient({
      region: config.aws_project_region,
    });

    const command = new GetUserAttributeVerificationCodeCommand({
      AccessToken: accessToken,
      AttributeName: "phone_number",
    });

    await client.send(command);

    return {
      success: true,
      message: "Código de verificación enviado al teléfono registrado",
    };
  } catch (error) {
    console.error("Error en SendPhoneVerificationCode:", error);
    return { success: false, error: error.message };
  }
};

export default SendPhoneVerificationCode;